import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import menujson from '../../Json/menu.json';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as React from 'react';
import ModuleCard from '../../Components/Card/ModuleCard';
import {makeStyles} from '@material-ui/core/styles';

const pathToParentMenu = ['root'];

const AssignListLayout = (props) => {
    const navigate = useNavigate();
    const [menuJson, setMenuJson] = useState(menujson);

    const classes = useStyles();
    return(
        <Grid container>
            {/* <GenerateMenu menuJson={menuJson} goToSubmenu={goToSubmenu}></GenerateMenu>
            {pathToParentMenu.length > 1 &&
                <Button variant="contained" color='secondary' onClick={backMenu}>Back</Button>
            } */}
            <Grid item xs={12}   sx={{height: "81vh", overflow: "auto"}}>
                <Grid>
                    <Grid item xs={12}>
                        <Grid container sx={{ flexDirection: 'row',flexWrap: 'wrap', gap: 3, justifyContent: 'flex-start',mt:1, pl: 7,pb: 2,}}>
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                            <ModuleCard />
                        </Grid>
                    </Grid>
                </Grid>
                
            </Grid>
        </Grid>
    )
}
const useStyles = makeStyles({
    scrollBar: {
        '&::-webkit-scrollbar': {
            width: '0.6em'
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            borderRadius: 5
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5
        }
    },
})
export default AssignListLayout;